/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Claims Icon
 */

/**
 * Claims Icon
 */
const ClaimsIcon: React.FC = () => {
	return (
		<span className='anticon anticon-icon'>
			<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-label='Claims'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2 1.99996C2 1.26358 2.59695 0.666626 3.33333 0.666626H12.6667C13.4031 0.666626 14 1.26359 14 1.99996V5.46586C14 5.83405 13.7015 6.13253 13.3333 6.13253C12.9651 6.13253 12.6667 5.83405 12.6667 5.46586V1.99996H3.33333V14H6.66667C7.03486 14 7.33333 14.2984 7.33333 14.6666C7.33333 15.0348 7.03486 15.3333 6.66667 15.3333H3.33333C2.59696 15.3333 2 14.7364 2 14V1.99996Z'
					fill='currentColor'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.66699 4.66667C4.66699 4.29848 4.96547 4 5.33366 4H9.66699C10.0352 4 10.3337 4.29848 10.3337 4.66667C10.3337 5.03486 10.0352 5.33333 9.66699 5.33333H5.33366C4.96547 5.33333 4.66699 5.03486 4.66699 4.66667Z'
					fill='currentColor'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.66699 7.00004C4.66699 6.63185 4.96547 6.33337 5.33366 6.33337H7.00033C7.36852 6.33337 7.66699 6.63185 7.66699 7.00004C7.66699 7.36823 7.36852 7.66671 7.00033 7.66671H5.33366C4.96547 7.66671 4.66699 7.36823 4.66699 7.00004Z'
					fill='currentColor'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.9997 11.3334C13.9997 9.86062 12.8058 8.66671 11.333 8.66671C9.86025 8.66671 8.66634 9.86062 8.66634 11.3334C8.66634 12.8061 9.86025 14 11.333 14C12.8058 14 13.9997 12.8061 13.9997 11.3334ZM11.333 7.33337C13.5421 7.33337 15.333 9.12424 15.333 11.3334C15.333 13.5425 13.5421 15.3334 11.333 15.3334C9.12387 15.3334 7.33301 13.5425 7.33301 11.3334C7.33301 9.12424 9.12387 7.33337 11.333 7.33337Z'
					fill='currentColor'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.3337 11.3334C11.7018 11.3334 12.0003 11.6319 12.0003 12V13C12.0003 13.3682 11.7018 13.6667 11.3337 13.6667C10.9655 13.6667 10.667 13.3682 10.667 13V12C10.667 11.6319 10.9655 11.3334 11.3337 11.3334Z'
					fill='currentColor'
				/>
				<path
					d='M11.3337 10.6667C11.7018 10.6667 12.0003 10.3682 12.0003 10C12.0003 9.63185 11.7018 9.33337 11.3337 9.33337C10.9655 9.33337 10.667 9.63185 10.667 10C10.667 10.3682 10.9655 10.6667 11.3337 10.6667Z'
					fill='currentColor'
				/>
			</svg>
		</span>
	);
};

export default ClaimsIcon;
